export default __webpack_public_path__ + "static/media/dental-surgeon.f0385c3d.png";